import React from 'react';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';

const ContactForm = () => {
	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
	} = useForm();

	return (
		<Form>
			<Form.Group controlId="fullName">
				<Form.Label>Your Name</Form.Label>
				<Form.Control
					type="text"
					className="rounded-0 shadow-none"
					{...register('fullName', {
						required: {
							value: true,
							message: 'Full Name is Required',
						},
					})}
				/>
				<label className="label">
					{errors.fullName?.type === 'required' && (
						<p className="text-danger">{errors.fullName.message}</p>
					)}
				</label>
			</Form.Group>
			<Form.Group controlId="emailAddress">
				<Form.Label>Email Address</Form.Label>
				<Form.Control
					type="text"
					className="rounded-0 shadow-none"
					{...register('emailAddress', {
						required: {
							value: true,
							message: 'Email address is required',
						},
					})}
				/>
				<label className="label">
					{errors.emailAddress?.type === 'required' && (
						<p className="text-danger">{errors.fullName.message}</p>
					)}
				</label>
			</Form.Group>
			<Form.Group controlId="message">
				<Form.Label>Message</Form.Label>
				<Form.Control
					as="textarea"
					rows={4}
					className="rounded-0 shadow-none"
					{...register('message', {
						required: {
							value: true,
							message: 'Message is required',
						},
					})}
				/>
				<label className="label">
					{errors.message?.type === 'required' && (
						<p className="text-danger">{errors.message.message}</p>
					)}
				</label>
			</Form.Group>
			<div className="d-flex justify-content-end">
				<Button
					variant="dark"
					type="submit"
					className="rounded-0 mt-2 variant-0 outline-0 px-4"
					style={{ height: '44px' }}
				>
					Send Message
				</Button>
			</div>
		</Form>
	);
};

export default ContactForm;
